import { defineMessages } from 'react-intl';

export default defineMessages({
	emailLabel: {
		defaultMessage: 'Email address',
		description: 'Label for login email field',
		id: 'cv.login.sso.customer.email.label',
	},
	continueWithPasswordButton: {
		defaultMessage: 'Continue with password',
		description: 'The button text for customer account login using password',
		id: 'cv.login.sso.customer.password.link.text',
	},
	continueWithSingleSignOnButton: {
		defaultMessage: 'Continue with single sign-on',
		description: 'The redirect button text for customer account login using single sign-on',
		id: 'cv.login.sso.customer.button.text',
	},
});
